<template>
  <div>
    <div class="ViewConsultants">
      <div class="consultor" v-for="(item, index) in Consultores" :key="index">
        <div class="imagen">
          <img :src="item.Image" />
        </div>
        <div class="informacion">
          <div class="nombre">{{ item.Name }}</div>
          <div class="contacto">
            <div class="texto">
              <p>{{ item.correo }}</p>
            </div>
            <div class="texto">
              <p>{{ item.tel }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    NewInteraction(data) {
      this.dataAux = data;
      this.Interaction = true;
    },
  },
  props: {
    Consultores: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="css" scoped>
.ViewConsultants {
  background: var(--second-color);
  position: absolute;
  top: 100%;
  left: 0px;
  right: 0px;
  height: auto;
  z-index: 2;
  box-shadow: 0px 5px 10px 0px var(--twelveth-color);
  border-radius: 5px;
  width: 100%;
}
.consultor {
  height: 60px;
  background: var(--second-color);
  margin: 15px;
  box-shadow: 0px 0px 20px -8px var(--twelveth-color);
  display: flex;
  flex-direction: row;
}
.ViewConsultants .consultor .imagen {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 5px;
}
.ViewConsultants .consultor .imagen img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.informacion {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  height: 100%;
}
.contacto {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.nombre {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #0b2257;
}
.texto {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #000;
}
@media (max-width: 665px) {
  .contacto {
    flex-direction: column;
  }
  .consultor {
    height: 90px;
    display: flex;
    align-items: center;
  }
  .ViewConsultants .consultor .imagen {
    margin-left: 10px;
  }
  @media (max-width: 376px) {
    .texto {
      font-size: 10px;
    }
  }
}
</style>